import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_CASHBOOK_HEAD_LIST,
  SAVE_CASHBOOK_HEAD,
  EDIT_CASHBOOK_HEAD_ID,
  UPDATE_CASHBOOK_HEAD_ID,
  DELETE_CASHBOOK_HEAD_ID,
} from "./actionTypes";
import {
  CashBookHead_List_API,
  CashBookHead_Single_Get_API,
  CashBookHead_Save_API,
  CashBookHead_Update_API,
  CashBookHead_Delete_API,
  CashBookHead_POST_API,
} from "../../../helpers/backend_helper";
import {
  cashBookHeadApiErrorAction,
  getCashBookHeadListSuccess,
  saveCashBookHeadSuccess,
  editCashBookHeadIDSuccess,
  updateCashBookHeadIDSuccess,
  deleteCashBookHeadIDSuccess,
} from "./action";
import { date_ymd_func, loginSelectedPartyID, loginUserIsFranchisesRole } from "../../../components/Common/CommonFunction";
import { url } from "../../../routes";


function* Get_CashBookHead_List_GenFun({ payload = "master" }) {
  try {
    let response;

    if (payload === "list") {
      // List page: single POST API, today's date, no cashier (0)
      response = yield call(
        CashBookHead_POST_API,
        JSON.stringify({
          PartyID: loginSelectedPartyID(),
          CashierID: 0,
          Date: date_ymd_func(),
        })
      );
    } else {
      // Master page: normal list API
      response = yield call(CashBookHead_List_API);
    }

    let data = Array.isArray(response.Data)
      ? response.Data
      : response.Data
        ? [response.Data]
        : [];

    // the POST API returns PartyHead_id, the list page (edit / delete buttons) expects id
    if (payload === "list") {
      data = data.map((row) => ({ ...row, id: row.PartyHead_id }));
    }

    yield put(getCashBookHeadListSuccess(data));
  } catch (error) {
    yield put(cashBookHeadApiErrorAction());
  }
}


function* Save_CashBookHead_GenFun({ config }) {            // save API
  try {
    const response = yield call(CashBookHead_Save_API, config);
    yield put(saveCashBookHeadSuccess(response));
  } catch (error) { yield put(cashBookHeadApiErrorAction()) }
}

function* Edit_CashBookHead_GenFun({ config }) {            // edit (single get) API
  const { btnmode } = config;
  try {
    const response = yield call(CashBookHead_Single_Get_API, config);
    response.pageMode = btnmode;
    yield put(editCashBookHeadIDSuccess(response));
  } catch (error) { yield put(cashBookHeadApiErrorAction()) }
}

function* Update_CashBookHead_GenFun({ config }) {          // update API
  try {
    const response = yield call(CashBookHead_Update_API, config);
    yield put(updateCashBookHeadIDSuccess(response));
  } catch (error) { yield put(cashBookHeadApiErrorAction()) }
}

function* Delete_CashBookHead_GenFun({ config }) {          // delete API
  try {
    const response = yield call(CashBookHead_Delete_API, config);
    yield put(deleteCashBookHeadIDSuccess(response));
  } catch (error) { yield put(cashBookHeadApiErrorAction()) }
}

function* CashBookHeadSaga() {
  yield takeLatest(GET_CASHBOOK_HEAD_LIST, Get_CashBookHead_List_GenFun)
  yield takeLatest(SAVE_CASHBOOK_HEAD, Save_CashBookHead_GenFun)
  yield takeLatest(EDIT_CASHBOOK_HEAD_ID, Edit_CashBookHead_GenFun)
  yield takeLatest(UPDATE_CASHBOOK_HEAD_ID, Update_CashBookHead_GenFun)
  yield takeLatest(DELETE_CASHBOOK_HEAD_ID, Delete_CashBookHead_GenFun)
}

export default CashBookHeadSaga;